import angular from 'angular';
import uiRouter from 'angular-ui-router';
import profilesComponent from './profiles.component';

let profilesModule = angular.module('app.containers.profiles', [
  uiRouter,
])

.config(($stateProvider) => {
  "ngInject";
  $stateProvider
    .state('profiles', {
      url: '/profiles',
      template: '<profiles></profiles>'
    })
    // .state('profiles', {
    //   url: '/profiles',
    //   template: '<profiles></profiles>'
    // })
})

.component('profiles', profilesComponent);

export default profilesModule;



/** WEBPACK FOOTER **
 ** E:/JUGGLE_STREET/Juggle-Street-Deployment-All/JSBIGFOOTFRONTEND-BACKEND/admin-frontend/client/app/containers/profiles/profiles.js
 **/